<template>
	<div style="display:none;">
        <div 
            class="map-marker" 
            :class="{special: home || special || point.special, ['class-' + point.computedIcon.font]: true}"
            ref="html"
            :style="{'background-color': bgColor, 'z-index': layer ? 100 - layer.order : null}"
        >
            <template v-if="home && ! point.noHomeOrigin">
                <i class="icon-home"></i>
            </template>

            <template v-if=" ! home || point.noHomeOrigin">
                <i 
                    v-if="point.computedIcon.font" 
                    :class="point.computedIcon.font"
                ></i>

                <img 
                    v-if="point.computedIcon.icon && ! point.computedIcon.font"
                    :src="$imgUrl(point.computedIcon.icon)"
                >
            </template>
        </div>
    </div>
</template>

<script>
import HTMLMarker from '@posterno/google-maps-html-marker'

export default {
    props: ['home', 'special', 'map', 'point'],

    mounted() {
        if ( ! this.$refs.html) {
            return
        }

        this.marker = HTMLMarker({
            latlng: new this.mapsApi.maps.LatLng(this.point.latitude, this.point.longitude),
            map: this.map,
            html: this.$refs.html.outerHTML,
        })

        if ( ! this.special && ! this.home && ! this.point.special) {
            this.marker.uid = this._uid
            this.$store.state.markers.push(this.marker)
        }

        this.initMarkerWindow()
    },

    computed: {
        bgColor() {
            if (this.point.computedIcon && this.point.computedIcon.bgColor) {
                return this.point.computedIcon.bgColor
            }

            return this.layer ? this.layer.icon_font_color : null
        },

        layer() {
            if ( ! this.point.pointCategoryIds || this.point.pointCategoryIds.length === 0) {
                return null
            }

            return this.$store.state.layers.find(layer => {
                let pointCategories = layer.point_categories.map(category => category.id)

                return pointCategories.includes(this.point.pointCategoryIds[0])
            })
        },

        mapsApi() {
            return this.$store.state.mapsApi
        },

        currentMarkerWindow: {
            get() {
                return this.$store.state.markerWindow
            }, 

            set(markerWindow) {
                this.$store.state.markerWindow = markerWindow
            }
        }
    },

    beforeDestroy() {
        this.$store.state.markers = this.$store.state.markers.filter(m => m.uid !== this._uid)
        this.marker.setMap(null)
    },

    methods: {
        assembleContent() {
            // Try to translate if matching language is found
            let match = this.point.translations?.find(t => t.attributes.lang === this.$store.state.endUser.language)
            let content = ''

            if ( ! this.point.title && ! this.point.fixedDesc && ! this.point.url) {
                return
            }

            if (match) {
                if (this.point.noHomeOrigin) {
                    if (match.attributes.title) { content = '<h3>' + match.attributes.title + '</h3><h4>' + this.__('start_point_info', '(Startpunkt. Du kan ändra vägvisningen.)') + '</h4>' }                    
                } else {
                    if (match.attributes.title) { content = '<h3>' + match.attributes.title + '</h3>' }
                }

                if (match.attributes.desc) { content += this.addRelToLinks(match.attributes.desc) }
                if (this.point.url) { content += '<a class="map-window-link" rel="noopener noreferrer nofollow" target="_blank" href="' + (match.attributes.url || this.point.url) + '">' + (match.attributes.url_text || this.point.computedUrlText) + '</a>' }
            } else {
                if (this.point.noHomeOrigin) {
                    if (this.point.title) { content = '<h3>' + this.point.title + '</h3><h4>' + this.__('start_point_info', '(Startpunkt. Du kan ändra vägvisningen.)') + '</h4>' }
                } else {
                    if (this.point.title) { content = '<h3>' + this.point.title + '</h3>' }
                }
                
                if (this.point.fixedDesc) { content += this.addRelToLinks(this.point.fixedDesc) }
                if (this.point.url) { content += '<a class="map-window-link" rel="noopener noreferrer nofollow" target="_blank" href="' + this.point.url + '">' + this.point.computedUrlText + '</a>' }
            }
            
            return '<div class="map-window">' + content + '</div>'
        },

        initMarkerWindow() {
            let content = this.assembleContent()

            this.markerWindow = new this.mapsApi.maps.InfoWindow({
                content, 
                maxWidth: 300,
                pixelOffset: new this.mapsApi.maps.Size(0, -18)
            })

            this.markerWindow.pointId = this.point.id

            this.marker.addListener('click', () => {
                this.markerWindow.setContent(this.assembleContent())

                event.stopPropagation()

                if (this.currentMarkerWindow) {
                    this.currentMarkerWindow.close()

                    if (this.currentMarkerWindow.pointId === this.point.id) {
                        this.currentMarkerWindow = null
                    }
                }
                
                this.currentMarkerWindow = this.markerWindow
                this.markerWindow.open(this.map, this.marker)

                this.$metric({
                    'event': 'point_interaction', 
                    'InteractionType': 'opened', 
                    'PointTitle': this.point.title, 
                    'PointCategory': this.point.pointCategoryTitles && this.point.pointCategoryTitles.length > 0 ? this.point.pointCategoryTitles[0] : null, 
                    'PointLocation': this.point.address || (this.latitude + ', ' + this.longitude)
                })
            })
        },

        addRelToLinks(html) {
            let whiteList = ['([^/]+.)?resvana.com']
            let str = '(<as*(?!.*\brel=)[^>]*)(href="https?://)((?!(?:' + whiteList.join('|') + '))[^"]+)"((?!.*\brel=)[^>]*)(?:[^>]*)>'

            return html.replace(new RegExp(str, 'igm'), '$1$2$3"$4 rel="noopener noreferrer nofollow" target="_blank">');
        },
    }
}
</script>